import './App.css';
import { useEffect, useState } from 'react';

class SixSevenCalc {
  constructor (inputSetter, opSetter, prevSetter, resSetter) {
    this.inputSetter = inputSetter
    this.opSetter = opSetter
    this.prevSetter = prevSetter
    this.resSetter = resSetter
  }

  setInput(res, input) {
    if (res) {
      this.prevSetter(null)
      this.opSetter(null)
      this.resSetter(null)
    }
    this.inputSetter(input)
  }

  clearAll() {
    this.prevSetter(null)
    this.opSetter(null)
    this.resSetter(null)
    this.inputSetter("")
  }

  clearInput(result) {
    if (result === null)
      this.inputSetter("")
  }

  setOp(oldPrev, prev, op, result) {
    if (prev === "" && oldPrev === null) // no input
      return

    if (result !== null) {
      prev = result
      this.resSetter(null)
      this.prevSetter(result)
      this.inputSetter("")
      this.opSetter(op)
      return
    }

    if (oldPrev === null) {
      this.prevSetter(prev)
    }
    this.inputSetter("")
    this.opSetter(op)
  }

  calcResult(prev, op, input) {
    if (input === "" || op === null)
      return
    this.resSetter(67)
  }
}

function HilariousButton(props) {
  const { label, cls, onClick } = props

  return <button key={label} className={`${cls} border border-black rounded-sm px-1.5`} onClick={onClick}>
    { label }
  </button>
}

function PopUp(prop) {
  const { hidden, setHidden } = prop
  return <div className={`absolute z-10 ${hidden ? "hidden" : ""}`}>
    <img src={"./img/give-roblox.png"} className={`h-[40rem] rounded-xl`}></img>
    <button className='absolute top-5 right-5 bg-white rounded-md px-4' onClick={() => setHidden(true)}>X</button>
  </div>
}

function App() {
  const [result, setResult] = useState(null)
  const [input, setInput] = useState("")
  const [op, setOp] = useState(null)
  const [prev, setPrev] = useState(null)
  const [popUp, setpopUp] = useState(true)

  const calculator = new SixSevenCalc(setInput, setOp, setPrev, setResult)

  useEffect(() => {
    document.getElementById("root").onclick = () => {
      document.getElementById("bg-audio").play()
    }
  }, [])

  const layout = [
    ['AC', 'CE', '%', '/'],
    ['7', '8', '9', 'X'],
    ['4', '5', '6', '-'],
    ['1', '2', '3', '+'],
    ['0', "="]
  ]

  const createButton = (label) => {
    if (label === "=") {
      return <HilariousButton label='=' 
        cls="col-span-3"
        onClick={() => {
          calculator.calcResult(prev, op, input)
          new Audio("./music/vine-boom.mp3").play()
        }}
      />
    } else if (label === 'AC') {
      return <HilariousButton label={label} 
        onClick={() => calculator.clearAll()} 
      />
    } else if (label === 'CE') {
      return <HilariousButton label={label} 
        onClick={() => calculator.clearInput(result)} 
      />
    } else if (['%', '/', 'X', '-', '+'].includes(label))
      return <HilariousButton label={label} 
        onClick={() => calculator.setOp(prev, input, label, result)}
      />
    else if (label === '.')
      return <HilariousButton label={label} />
    else
      return <HilariousButton label={label} 
        onClick={() => calculator.setInput(result, (result) ? label : input + label)}
      />
  }

  return (
    <>
      <PopUp setHidden={setpopUp} hidden={popUp}></PopUp>
      <div className='calculator-main border border-black rounded-md p-5 w-md bg-white z-[2] slow-spin up-n-down'>
        <div className="result text-right text-[1rem] h-[1.5rem]">
          {prev} {op ? op : ""} {result ? input : ""}
        </div>
        <div className="result text-right mb-3 min-h-[5rem] bg-gray-300 gap-0 flex flex-col items-end gap-1 pb-2 rounded-md">
          <div className='self-stretch px-1.5'>{ result ? result : input }</div>
          {result && <button className='text-[1rem] bg-gray-500 text-white px-1.5 rounded-lg' onClick={() => setpopUp(false)}>Get real answer</button>}
        </div>
        <div className="cool-button-area grid grid-cols-4 gap-1">
          {
            layout.map((sublist) => 
              sublist.map(createButton)
          )
        }
        </div>
      </div>
      <span className='absolute z-[1] text-[50rem]/[1] overflow-hidden rainbow-font'>67</span>
    </>
  );
}

export default App;
